(() => {
  if (window.nidoMegaMenuOverlayInitialized) return;
  window.nidoMegaMenuOverlayInitialized = true;

  const getOverlay = (event) => event.target.closest('[data-nido-mega-menu-overlay]');

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!getOverlay(event)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const overlay = getOverlay(event);
      if (!overlay) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const headerSection = overlay.closest('.section-header') || document;

      headerSection.querySelectorAll('.nido-desktop-navigation details[open]').forEach((details) => {
        const disclosure = details.closest('details-disclosure');

        if (disclosure && typeof disclosure.close === 'function') {
          disclosure.close();
          return;
        }

        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });
    },
    true
  );
})();
